<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Number Series</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon small @click="fn_checkValidations">save</v-btn>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>
		</v-toolbar>

		<v-form class="form-element hasToolbar grey-back mb-2">

			<v-layout row wrap pt-2 white-background>
			  	<v-flex xs12 sm12 md12 form-item>
	               <v-text-field v-model="Form.name" label="Name" placeholder=" " v-validate="'required'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
	            </v-flex>
			</v-layout>

			<v-layout wrap mb-2 mt-2 class="form_wrapper" v-for="(item, index) in Form.transactionNumbers" :key="index">

				<v-layout wrap padding-bottom-ten white-background>

					<v-subheader dark-grey full-width>Fiscal Year {{item.fiscalYear}}</v-subheader>

		            <v-flex xs12 sm12 md12 form-item>
		               <v-text-field  v-model="item.prefix" label="Prefix" placeholder=" " v-validate="'required'" :error-messages="errors.collect('prefix'+index)" :data-vv-name="'prefix'+index" data-vv-as="prefix" required></v-text-field>
		            </v-flex>

		            <v-flex xs12 sm12 md12 form-item>
		               <v-text-field  v-model="item.nextNumber" label="Next Number" type="number" placeholder=" " v-validate="'required|max:9'" :error-messages="errors.collect('nexNumber'+index)" :data-vv-name="'nexNumber'+index" data-vv-as="next number" required></v-text-field>
		            </v-flex>

		            <v-flex xs12 sm12 md12 form-item>
		               <v-text-field  v-model="item.suffix" label="Suffix" placeholder=" "></v-text-field>
		            </v-flex>

				</v-layout>

			</v-layout>

			<v-alert :value="true" color="info" class="pt-3 pb-3">
		      	<ul>
	    		    <li class="mb-3">A commulative number series (prefix+number+suffix) cannot be greater than 16 characters.</li>
	    		    <li>Prefix and suffix in series can only contain alphanumeric and "<strong>/</strong>" or "<strong>-</strong>" characters.</li>
	    		</ul>
		    </v-alert>

		</v-form>

		

	    <v-dialog v-model="loading" no-click-animation no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	</div>
</template>

<script>
const menuItem = require('../../config.js').configs.menuItem;

	export default{
		data(){
			return{

				Form:{"numberSeriesId":null, "name":null, "isSystem":0, "transactionNumbers":[]},

				fyData: {"numberSeriesId":null, "prefix":null, "suffix":null, "nextNumber":null, "transactionNumberId":null, "fiscalYear":null},

				currentFiscalYear:null,

				loading:false,
				
				backButtonPress: false,

				snackbar:false,
				snackbar_msg:null
			}
		},
		methods:{

			fn_getBottomMenu: function (tagId) {
				var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {

			        	this.fn_validateSeries()
			          	return; 
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			    });
			},

			fn_validateSeries: function(){

				let valid = true;
				if(this.mergedSeries.length>16){
					valid = false;
				}

				let pattern = /^[0-9a-zA-Z/ -]+$/;
				if(!pattern.test(this.mergedSeries)){
					valid = false;
				}

				if(!valid){
					this.showToast("Number series criteria not matched");
					return;
				}

				this.fn_post();
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('NumberSeries', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	self.showToast("Already exists with this name");
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_get: function(itemId){
				var self = this;
				this.getData('NumberSeries', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.fn_bindData(data);
							// self.Form = JSON.parse(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function(data){

				this.Form.numberSeriesId = data.numberSeriesId;
				this.Form.name = data.name;
				this.Form.isSystem = data.isSystem;

				if(this.currentFiscalYear < 2020){
					data.transactionNumbers.sort(function(a, b) { return parseFloat(a.fiscalYear) - parseFloat(b.fiscalYear) });
				}
				else{
					data.transactionNumbers.sort(function(a, b) { return parseFloat(b.fiscalYear) - parseFloat(a.fiscalYear) });
				}

				this.Form.transactionNumbers = [];

				for(let i in data.transactionNumbers){
					this.Form.transactionNumbers.push(data.transactionNumbers[i]);
				}

			},

			fn_cleanUp: function () {
				if(this.$route.query.ls){
					let data = {};
					data.type = 'numberSeries';
					data.id = this.Form.numberSeriesId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

	          	this.$router.go(-1);
			},

			fn_post: function(){
				!this.Form.numberSeriesId ? this.Form.numberSeriesId = this.guid() : '';
				this.Form.name = this.Form.name.trim();

				let postObj = {};
				postObj.defaultDataJson = {};
				postObj.defaultDataJson.numberSeries = [];

				let numberSeriesObj = {};
				numberSeriesObj.numberSeriesId = this.Form.numberSeriesId;
				numberSeriesObj.name = this.Form.name;
				numberSeriesObj.isSystem = this.Form.isSystem;
				numberSeriesObj.transactionNumbers = [];

				for(let i in this.Form.transactionNumbers){
					let transNumObj = {};
					transNumObj.transactionNumberId = this.Form.transactionNumbers[i].transactionNumberId ? this.Form.transactionNumbers[i].transactionNumberId : this.guid();
					transNumObj.prefix = this.Form.transactionNumbers[i].prefix;
					transNumObj.suffix = this.Form.transactionNumbers[i].suffix;
					transNumObj.nextNumber = this.Form.transactionNumbers[i].nextNumber;
					transNumObj.fiscalYear = this.Form.transactionNumbers[i].fiscalYear;
					transNumObj.numberSeriesId = this.Form.numberSeriesId;
					numberSeriesObj.transactionNumbers.push(transNumObj);
				}

				postObj.defaultDataJson.numberSeries.push(numberSeriesObj);

				console.log(postObj);
				this.fn_saveLocal(postObj);
			},

			fn_clearForm: function(){
				if(this.Form.numberSeriesId){
					this.fn_get(this.Form.numberSeriesId);
				}
				else{
					this.Form = {"numberSeriesId":null, "name":null, "isSystem":0, "transactionNumbers":[]};
					this.fn_initializeData();
				}
				
				this.$validator.reset();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.fn_clearForm();
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_initializeData: function(){
				this.fyData.fiscalYear = this.currentFiscalYear;
				this.Form.transactionNumbers.push(JSON.parse(JSON.stringify(this.fyData)));
				// this.fyData.fiscalYear = this.currentFiscalYear < 2020 ? "2020" : "2019";
				// this.Form.transactionNumbers.push(JSON.parse(JSON.stringify(this.fyData)));
				console.log(JSON.stringify(this.transactionNumbers));
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
			}

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			let dateObj = new Date();
            let month = dateObj.getMonth() + 1;
            let year = dateObj.getFullYear();
            let fy = month > 3 ? year : year-1;
			this.currentFiscalYear = JSON.stringify(fy);
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(from.name=='numberSeriesItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		if(itemId){
		  			vm.fn_get(itemId);
		  		}
		  		else{
		  			vm.fn_initializeData();
		  		}
		  	})
		},
		computed:{
			mergedSeries: function(){
				return this.Form.prefix + this.Form.nextNumber + this.Form.suffix;
			}
		}
	}

</script>


// WEBPACK FOOTER //
// src/components/number_series/form2.vue